/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createLog2 } from '../../factoriesAny.js';
export var log2Dependencies = {
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createLog2: createLog2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLog2.generated.js
// module id = 1444
// module chunks = 0